import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "messageRecerverlist",
  tabindex: "-1",
  "aria-labelledby": "moreuserModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "moreuserModalLabel"
}, "Message Receivers", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = { class: "round-img" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "send-icon-wrap"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideMemberListModal && _ctx.hideMemberListModal(...args)))
            }, [
              _hoisted_7
            ])
          ]),
          (_ctx.membersList && _ctx.membersList.length)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.membersList, (member, memberIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "member-list pr-0",
                    key: memberIndex
                  }, [
                    _createVNode("div", _hoisted_9, [
                      (member.status === 1 && !member.sender)
                        ? (_openBlock(), _createBlock("span", _hoisted_10, [
                            _createVNode("span", null, [
                              _createVNode("img", {
                                src: member.image,
                                alt: member.email,
                                title: `${member.full_name} (${member.email} )`
                              }, null, 8, ["src", "alt", "title"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (member.status === 2 && !member.sender)
                        ? (_openBlock(), _createBlock("span", _hoisted_11, [
                            (member.status === 2)
                              ? (_openBlock(), _createBlock("span", _hoisted_12, [
                                  _hoisted_13
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("span", null, [
                              _createVNode("img", {
                                src: member.image,
                                alt: member.email,
                                title: `${member.full_name} (${member.email} )`
                              }, null, 8, ["src", "alt", "title"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (member.status === 1 && !member.sender)
                      ? (_openBlock(), _createBlock("p", _hoisted_14, "Message delivered to " + _toDisplayString(member.email), 1))
                      : _createCommentVNode("", true),
                    (member.status === 2 && !member.sender)
                      ? (_openBlock(), _createBlock("p", _hoisted_15, "Message seen by " + _toDisplayString(member.email), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_16, [
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              "data-dismiss": "modal",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideMemberListModal && _ctx.hideMemberListModal(...args)))
            }, " Close ")
          ])
        ])
      ])
    ])
  ]))
}